module.exports = __webpack_public_path__ + "static/img/gaozhonglishi8.424c8ffd.jpg";